import { ArticlePublisher } from '@/cmsComponents/ArticlePublisher';
import CmsImage from '@/cmsComponents/CmsImage';
import { PATH } from 'constants/path';
import Link from 'next/link';
import React from 'react';
import { IArticleSummary } from 'types/cms';

import Typography from '@material-ui/core/Typography';

import { defaultAlt } from 'components/Image';

import styles from './style.module.scss';

interface ArticleItemTopWithBgProps {
  article: IArticleSummary;
  onClick: () => void;
}

export const ArticleItemTopWithBg: React.FC<ArticleItemTopWithBgProps> = ({ article, onClick }) => {
  return (
    <div className={styles.container}>
      <Link
        prefetch={false}
        href={`${PATH.ARTICLES}/${article.slug}`}
        as={`${PATH.ARTICLES}/${article.slug}`}
        className={styles.link}
        role={'link'}
        tabIndex={0}
        onClick={onClick}
      >
        <div className={styles.cover}>
          {article.cover && (
            <CmsImage
              altText={article.cover.alternativeText || defaultAlt}
              imageProps={article.cover}
              className={styles.image}
              format="small"
              layout="fill"
            />
          )}
          <div className={styles.topLeft}>{article.article_category?.name}</div>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <Typography variant="h6" component="h2">
              {article.title}
            </Typography>
          </div>
          <div className={styles.blurb}>{article.blurb}</div>
          <ArticlePublisher author={article.author} publishedDate={article.published_date} />
        </div>
      </Link>
    </div>
  );
};
